export default function isValidMexicanPhone(phone) {
  // Remove spaces, dashes, and parentheses
  const cleanPhone = phone.replace(/[\s-()]/g, "");

  // Must start with +52 and be followed by exactly 10 digits
  const regex = /^\+52\d{10}$/;

  if (!cleanPhone.startsWith("+52")) {
    return {
      success: false,
      message: "El número debe comenzar con el código de país +52",
    };
  }

  if (!regex.test(cleanPhone)) {
    return {
      success: false,
      message: "El formato debe ser +52 seguido de 10 dígitos numéricos",
    };
  }

  return { success: true, message: "Número válido" };
}

